import {Component} from '@angular/core';
import {LoanApplicationService} from '../loan-application.service';
import {LoanApplication} from '../../../@models/loan-application.model';
import {CountrySelectService} from '../../../@modules/country-select/country-select.service';
import {JobCategorySelectService} from 'src/app/@modules/job-category-select/job-category-select.service';

@Component({
  selector: 'bb-employment-info',
  templateUrl: './employment-info.component.html',
  styleUrls: ['./employment-info.component.scss'],
})
export class EmploymentInfoComponent {
  employment_type = LoanApplication.EmploymentType;
  employment_info = this.loan.form.get('employment_info');
  employment_channel = LoanApplication.EmploymentChannel;

  requiredFields = {
    land: [
      'destined_country', 
      'job_title',
      'job_category',
      'monthly_salary',
      'employment_channel',
      'employer_name'
    ],
    sea: [
      'job_title',
      'job_category',
      'monthly_salary',
      'manning_agency'
    ]
  };

  isUpdating = false;

  constructor(public loan: LoanApplicationService,
              public country: CountrySelectService,
              public jobCategory: JobCategorySelectService) {
    this.employment_info.get('employment_type').valueChanges.subscribe(value => {
      if (this.isUpdating) {
        return;
      }
      this.isUpdating = true;
      const nonRequiredFields: string[] = Object.keys(this.employment_info.value).filter((field) => {
        return !this.requiredFields[value].includes(field);
      });
      nonRequiredFields.forEach((field) => {
        const control = this.employment_info.get(field);
        control.clearValidators();
        control.updateValueAndValidity();
      });
      this.isUpdating = false;
    });

    // Additional check for required fields by employment channel
    this.employment_info.get('employment_channel').valueChanges.subscribe(value => {
      if (value !== this.employment_channel.agency) {
        this.employment_info.get('recruitment_agency').clearValidators();
        this.employment_info.get('recruitment_agency').updateValueAndValidity();
      }
    });
  }
}
